import { useState } from 'react'

import { Drawer } from '@loadsmart/miranda-react'

import { type OpenDockStopAppointment, type OpenDockWarehouseDetails } from '../../domain/Shipment'
import { AppointmentCancelDialog } from './AppointmentCancelDialog'
import { StepContent } from './StepContent'

export type OpenDockAppointmentScheduledDrawerProps = {
  isOpen: boolean
  onClose: () => void
  stopAppointment?: OpenDockStopAppointment
  warehouseDetails?: OpenDockWarehouseDetails
  facilityName?: string
  facilityTimezone?: string
  shipmentUUID: string
  stopIndex: number
}

export function OpenDockAppointmentScheduledDrawer({
  isOpen,
  onClose,
  stopAppointment,
  warehouseDetails,
  facilityName,
  facilityTimezone,
  shipmentUUID,
  stopIndex,
}: OpenDockAppointmentScheduledDrawerProps) {
  const [isCancelDialogOpen, setIsCancelDialogOpen] = useState(false)

  return (
    <>
      <Drawer open={isOpen} onClose={onClose}>
        <StepContent
          isOpen={isOpen}
          stopAppointment={stopAppointment}
          warehouseDetails={warehouseDetails}
          facilityName={facilityName}
          facilityTimezone={facilityTimezone}
          shipmentUUID={shipmentUUID}
          stopIndex={stopIndex}
          onCancelAppointment={() => setIsCancelDialogOpen(true)}
        />
      </Drawer>
      <AppointmentCancelDialog
        isOpen={isCancelDialogOpen}
        onClose={() => setIsCancelDialogOpen(false)}
        onConfirm={() => setIsCancelDialogOpen(false)}
      />
    </>
  )
}
